import React, {Fragment, useCallback, useState} from "react";
import NavigationLayout from "../../Components/NavigationLayout";
import {Loading, PageActions, TextField, TextStyle, Toast} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import {useNavigate} from "react-router-dom";
import LoadingBtn from "../../Components/LoadingBtn";

const ImportByReferenceNumber = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [entryReferenceNumber, setEntryReferenceNumber] = useState("");
    const [error, setError] = useState("");
    const [toastActive, setToastActive] = useState(false);
    const [toastContent, setToastContent] = useState("");
    const toggleActiveToast = useCallback(
        () => setToastActive((toastActive) => !toastActive),
        []
    );
    // const [allEvents, setAllEvents] = useState([]);
    // const [selectedEvent, setSelectedEvent] = useState({});

    const toastMarkup = toastActive ? (
        <Toast content={toastContent} onDismiss={toggleActiveToast}/>
    ) : null;

    // useEffect(() => {
    //     fetchAllEvents();
    // }, []);
    // const fetchAllEvents = () => {
    //     setIsLoading(true);
    //     axios
    //         .get(`admin/v1/accreditation-types`)
    //         .then((res) => {
    //             const response = res?.data?.data;
    //             setAllEvents(response);
    //         })
    //         .catch((err) => console.log("error :", err))
    //         .finally(() => setIsLoading(false));
    // };

    // const eventOptions = allEvents.map((event) => ({
    //     label: event?.type?.en || `Event #${event.id}`,
    //     value: event.id.toString(),
    // }));
    //
    // const handleEventSelect = (selectedId) => {
    //     const selected = allEvents.find((ev) => ev.id === parseInt(selectedId, 10));
    //     if (selected) {
    //         setSelectedEvent(selected);
    //     }
    // };

    function handleSave() {
        if (!entryReferenceNumber) {
            setError('Entry Reference Number is required.');
            return;
        }

        setIsSaving(true);
        setError('');
        const form_data = new FormData();
        form_data.append("entry_reference_number", entryReferenceNumber);
        // form_data.append("accreditation_type_id", selectedEvent?.id);

        axios
            .post("admin/v1/applications/import", form_data)
            .then((res) => {
                setIsSaving(false);
                console.log(res);
                if (res.data.success) {
                    setToastActive(true);
                    setToastContent(res.data.message);
                    setEntryReferenceNumber('');
                } else {
                    setError(res.data.message);
                }
            })
            .catch(function (error) {
                setIsSaving(false);
            });
    }


    const loadingMarkup = isLoading
        ? <Fragment>
            <Loading/>
            <div className="spinnerContainer-x is-loading">
                <div className="vertical-center">{isLoading && <LoadingBtn/>}</div>
            </div>
        </Fragment>
        : null;

    return (
        <NavigationLayout>

            {loadingMarkup}
            <div className="container col-sm-12">
                {/*<div className="row col-sm-8 px-0 py-5">*/}
                {/*    <h3 className="fw-bolder">Select Event</h3>*/}
                {/*    <Select*/}
                {/*        placeholder="Select Event"*/}
                {/*        options={eventOptions}*/}
                {/*        onChange={handleEventSelect}*/}
                {/*        value={selectedEvent?.id?.toString() || ''}*/}
                {/*        disabled={isLoading}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className="row col-sm-8 px-0">
                    <TextField
                        value={entryReferenceNumber}
                        align="left"
                        onChange={setEntryReferenceNumber}
                        error={error}
                        label="Entry Reference Number"
                        requiredIndicator={true}
                    />
                </div>
                <div className="row col-sm-8 px-0">
                    <PageActions
                        primaryAction={{
                            content: <p style={{color: "white"}}>Save</p>,
                            onClick: handleSave,
                            loading: isSaving && true,
                        }}
                    />
                </div>
                {toastMarkup}
            </div>

        </NavigationLayout>
    );
}

export default ImportByReferenceNumber;
